import { Group } from '@/types/group';
import { useSelectOptions } from './use-select-options';

export const useGroupSelectOptions = (groups: Group[]) =>
  useSelectOptions<number, Group, 'groupName', 'id'>(groups, 'groupName', 'id');
